// ========== MethodPage.jsx ==========
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './StaticPages.css';
import AdUnit from '../components/AdUnit';
import AdRotator from '../components/AdRotator';

const MethodPage = () => {
  const navigate = useNavigate();

  return (
    <div className="static-page">
      <header className="static-header">
        <nav className="static-nav">
          <div className="logo" onClick={() => navigate('/')}> Mellodai</div>
          <a onClick={() => navigate('/')}> Back to Home</a>
        </nav>
      </header>
      {/* Place the AdUnit adsense component here */}
    <section className="headerAd">
      <AdRotator floating={true} placement="sidebar" />
       {/* <AdUnit adSlot="8074484061" /> */}
      </section>
      <div className="content-container">
        <div className="hero" style={{padding: '80px 2rem 40px', marginTop: 0}}>
          <h1> The Method</h1>
          <p>How Science, Data, and AI Predict Your Probability</p>
        </div>

        <div className="content-section">
          <h2> 1. The Scientific Method</h2>
          <p>The scientific method forms the bedrock of our AI: observation, hypothesis, testing with data, and conclusion.</p>
          <p>This rigorous, testable approach ensures our results are based on evidence, not guesswork.</p>
        </div>

        <div className="content-section">
          <h2> 2. Population Statistics</h2>
          <p>Individual experiences are unique, but human behavior at scale reveals predictable patterns.</p>
          <ul>
            <li><strong>The Dataset:</strong> 10,000+ statistically surveyed individuals over 25 years</li>
            <li><strong>Identifying Norms:</strong> Common sequences and timelines of major life events</li>
            <li><strong>Establishing Likelihood:</strong> Compare your sequence to population trends</li>
          </ul>
          <p>The bigger the data population, the more reliable the prediction.</p>
        </div>

        <div className="content-section">
          <h2> 3. Machine Learning</h2>
          <p>Machine Learning teaches computers to see connections that humans can't track.</p>
          <ul>
            <li><strong>Not Coded Logic:</strong> Fed all historical data to find patterns automatically</li>
            <li><strong>The Neural Network:</strong> Complex layers of calculations mimicking the brain</li>
          </ul>
        </div>

        <div className="content-section">
          <h2> 4. The AI Event Prediction Model</h2>
          <p>When you submit your events, the AI performs real-time calculation:</p>
          <ol style={{marginLeft: '2rem', lineHeight: '2'}}>
            <li>You provide your unique sequence of events</li>
            <li>Neural Network compares against 25 years of data</li>
            <li>System analyzes: "What percentage of people with this sequence experienced X next?"</li>
            <li>Output: A precise, data-backed probability score with timing insights</li>
          </ol>
        </div>

        <div className="cta-section">
          <button className="btn-primary" onClick={() => navigate('/login')}>Try Your First Prediction</button>
        </div>
      </div>

      <footer className="static-footer">
        <p>&copy; 2025 Mellodai. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default MethodPage;
